import { components, OptionProps, GroupBase } from "react-select";
import classNames from "classnames";

type OptionOverrideProps<OptionType> = OptionProps<OptionType, false, GroupBase<OptionType>> & {
	stableClassName?: string;
	// react-select's own Option only forwards `getStyleProps` (css + className), its ref and
	// `innerProps` to the DOM — a bare `data-testid` prop would be silently dropped, so the
	// testid has to travel through `innerProps`.
	stableTestId?: string;
};

const Option = <OptionType,>({
	children,
	stableClassName,
	stableTestId,
	innerProps,
	...props
}: OptionOverrideProps<OptionType>) => (
	<components.Option
		className={classNames("react-select-field-option", stableClassName)}
		{...props}
		innerProps={{ ...innerProps, ...(stableTestId && { "data-testid": stableTestId }) }}
	>
		{children}
	</components.Option>
);

export { Option };
